import React from 'react'

const Eventsettlementpage = () => {
    return (
        <div>

        </div>
    )
}

export default Eventsettlementpage
